const {Component} = require("react");
const PropTypes = require("prop-types");
const Image = require("app/components/mixins/Image");
const router = require("app/services/router");

class Tooltip extends Component {

	static get propTypes() {
		return {
			content: PropTypes.string.isRequired,
			position: PropTypes.string,
			multiline: PropTypes.bool,
			positionMobile: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			position: "s",
			positionMobile: "s",
			multiline: true
		}
	}

	get className() {
		let classList = ["tooltipped"];

		// Position
		classList.push(`tooltipped-${this.props.position}`);
		classList.push(`tooltipped-${this.props.positionMobile}-mobile`);

		// Multiline
		if (this.props.multiline) {
			classList.push("tooltipped-multiline");
		}

		return classList.join(" ");
	}

	render() {
		return (
			<span className={this.className} aria-label={this.props.content}>
				<div className={'sprite'} lazy-load={'true'} critical={'true'} cssbg={router.url("img/icons/icons.png")} ></div>
			</span>
		);
	}

}

module.exports = Tooltip;
